import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaEnvelope } from 'react-icons/fa';
import './OurStaff.css';

const OurStaff = () => {
  const coaches = [
    {
      name: 'Rajesh Kumar',
      role: 'Head Coach & Founder',
      image: 'https://randomuser.me/api/portraits/men/75.jpg',
      experience: '20+ years',
      specialization: 'Singles Strategy & Technique',
      achievements: [
        'Former National Champion (1998, 2000)',
        'Arjuna Award Nominee',
        'BWF Certified Level 3 Coach',
        'Trained 50+ National Level Players'
      ],
      bio: 'Coach Rajesh founded Imperial Badminton Academy in 2009 with a vision to create world-class players. His deep understanding of the game and ability to nurture talent has made him one of the most respected coaches in the country.'
    },
    {
      name: 'Meera Singh',
      role: 'Senior Coach - Doubles',
      image: 'https://randomuser.me/api/portraits/women/65.jpg',
      experience: '15+ years',
      specialization: 'Doubles & Mixed Doubles',
      achievements: [
        'Former National Doubles Champion',
        'Asian Games Participant (2006)',
        'BWF Certified Level 2 Coach',
        'Specialist in Doubles Strategy'
      ],
      bio: 'Coach Meera brings international experience and expertise in doubles play. Her strategic insights and training methods have helped numerous pairs achieve success at national and international levels.'
    },
    {
      name: 'Arjun Reddy',
      role: 'Youth Development Coach',
      image: 'https://randomuser.me/api/portraits/men/45.jpg',
      experience: '12+ years',
      specialization: 'Junior Training & Development',
      achievements: [
        'Former State Champion',
        'Certified Youth Sports Coach',
        'Developed 100+ Junior Players',
        'Child Psychology Training'
      ],
      bio: 'Coach Arjun specializes in working with young players, making learning fun while building strong fundamentals. His patient approach and ability to connect with children make him invaluable to our academy.'
    },
    {
      name: 'Sunita Devi',
      role: 'Fitness & Conditioning Coach',
      image: 'https://randomuser.me/api/portraits/women/55.jpg',
      experience: '10+ years',
      specialization: 'Sports Fitness & Conditioning',
      achievements: [
        'Certified Strength & Conditioning Specialist',
        'Sports Science Degree',
        'Worked with Professional Athletes',
        'Injury Prevention Specialist'
      ],
      bio: 'Coach Sunita ensures our players are in peak physical condition. Her scientific approach to fitness training has significantly improved player performance and reduced injuries at the academy.'
    },
    {
      name: 'Vikram Sharma',
      role: 'Technical Coach',
      image: 'https://randomuser.me/api/portraits/men/32.jpg',
      experience: '8+ years',
      specialization: 'Stroke Mechanics & Footwork',
      achievements: [
        'Former National Ranking Player',
        'BWF Certified Level 2 Coach',
        'Video Analysis Expert',
        'Specialized in Technique Correction'
      ],
      bio: 'Coach Vikram focuses on perfecting stroke mechanics and footwork. His attention to detail and use of video analysis helps players identify and correct technical flaws effectively.'
    },
    {
      name: 'Priya Nair',
      role: 'Women\'s Program Coach',
      image: 'https://randomuser.me/api/portraits/women/44.jpg',
      experience: '10+ years',
      specialization: 'Women\'s Coaching',
      achievements: [
        'Former State Champion',
        'Women in Sports Advocate',
        'Certified Mental Skills Coach',
        'Developed Several State Level Players'
      ],
      bio: 'Coach Priya leads our women\'s program with passion and dedication. She focuses on empowering female players and has been instrumental in increasing women\'s participation at the academy.'
    },
  ];

  const support = [
    {
      name: 'Dr. Anil Kapoor',
      role: 'Sports Physiotherapist',
      image: 'https://randomuser.me/api/portraits/men/52.jpg',
      description: 'On-site physiotherapy for injury prevention and rehabilitation.'
    },
    {
      name: 'Neha Gupta',
      role: 'Sports Nutritionist',
      image: 'https://randomuser.me/api/portraits/women/68.jpg',
      description: 'Personalized nutrition plans for optimal performance.'
    },
    {
      name: 'Ravi Menon',
      role: 'Academy Manager',
      image: 'https://randomuser.me/api/portraits/men/36.jpg',
      description: 'Handles operations, scheduling, and member services.'
    },
    {
      name: 'Anita Thomas',
      role: 'Admissions Coordinator',
      image: 'https://randomuser.me/api/portraits/women/42.jpg',
      description: 'Your first point of contact for enrollment and inquiries.'
    },
  ];

  return (
    <div className="our-staff-page">
      <div className="page-header">
        <div className="container">
          <h1>Our Staff</h1>
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Our Staff</span>
          </div>
        </div>
      </div>

      <section className="staff-intro section">
        <div className="container">
          <div className="section-title">
            <span className="section-subtitle">Meet the Team</span>
            <h2>Expert Coaches & Staff</h2>
            <p>
              Our team of experienced coaches and support staff are dedicated to helping
              you achieve your badminton goals. Learn from the best in the industry.
            </p>
          </div>
        </div>
      </section>

      <section className="coaches-section section bg-light">
        <div className="container">
          <h2 className="coaches-heading">Coaching Team</h2>
          <div className="coaches-detailed-grid">
            {coaches.map((coach, index) => (
              <div key={index} className="coach-detailed-card">
                <div className="coach-image-wrapper">
                  <img src={coach.image} alt={coach.name} />
                  <div className="coach-social">
                    <a href="#" aria-label="Facebook"><FaFacebookF /></a>
                    <a href="#" aria-label="Twitter"><FaTwitter /></a>
                    <a href="#" aria-label="LinkedIn"><FaLinkedinIn /></a>
                    <a href="#" aria-label="Email"><FaEnvelope /></a>
                  </div>
                </div>
                <div className="coach-details">
                  <h3>{coach.name}</h3>
                  <p className="coach-role">{coach.role}</p>
                  <div className="coach-meta">
                    <span><strong>Experience:</strong> {coach.experience}</span>
                    <span><strong>Specialization:</strong> {coach.specialization}</span>
                  </div>
                  <p className="coach-bio">{coach.bio}</p>
                  <div className="coach-achievements">
                    <h4>Key Achievements:</h4>
                    <ul>
                      {coach.achievements.map((achievement, idx) => (
                        <li key={idx}>{achievement}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="support-section section">
        <div className="container">
          <div className="section-title">
            <span className="section-subtitle">Support Team</span>
            <h2>Behind the Scenes</h2>
            <p>
              Our dedicated support staff ensures smooth operations and
              comprehensive care for all our members.
            </p>
          </div>
          <div className="support-grid">
            {support.map((member, index) => (
              <div key={index} className="support-card">
                <img src={member.image} alt={member.name} />
                <h3>{member.name}</h3>
                <p className="support-role">{member.role}</p>
                <p className="support-desc">{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="join-team section bg-light">
        <div className="container">
          <div className="cta-box">
            <h2>Want to Join Our Team?</h2>
            <p>
              We're always looking for passionate coaches and professionals to join
              the Imperial family. If you share our vision of excellence, get in touch!
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-accent">
                Apply Now
              </Link>
              <a href="mailto:careers@imperialbadminton.com" className="btn btn-secondary">
                careers@imperialbadminton.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurStaff;
